import { filter, distinctUntilChanged, debounceTime, tap, switchMap, finalize } from 'rxjs/operators';
import { Component, OnInit, ViewChild } from '@angular/core';
import { DataManager, WebApiAdaptor, Query} from '@syncfusion/ej2-data';
import { GridComponent, PageSettingsModel, SelectionSettingsModel, ToolbarItems } from '@syncfusion/ej2-angular-grids';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { isNumber } from 'highcharts';

import { SharedFunctions } from '../../../../../src/app/shared/shared.functions';

import { ProveedorService, MenuFuncionService, PedidoService, TipoMaterialService, MaterialesService } from '../../../../../src/app/shared/services';
import { GridPageSettings, MaterialDto, MenuFuncionCodes, Pais, PedidoRemitoDetalle, Proveedor, SearchMaterialRequest, SearchProveedorRequest, SearchReporteEntregaRequestDto, SearchTipoMaterialRequest, TipoMaterialDto } from '../../../../../src/app/shared/model';
import { ExportMediaTypeConstants } from '../../../shared/model';

@Component({
  selector: 'app-reporte-entregas',
  templateUrl: './reporte-entregas.component.html',
  styleUrls: ['./reporte-entregas.component.scss']
})
export class ReporteEntregasComponent implements OnInit {
  @ViewChild('grid')
  public grid: GridComponent;

  public data: DataManager;
  total: number = 0;
  searchForm: FormGroup;

  isValidating: boolean = false;
  isTipoMaterialSearching: boolean = false;
  isSearching: boolean = false;
  isExporting: boolean = false;

  canView: boolean = false;
  canViewProveedor: boolean = false;
  canViewPedido: boolean = false;

  isTipoSearching: boolean = false;
  isComunidadSearching: boolean = false;
  isMaterialAutoSearching: boolean = false;
  isProveedorSearching: boolean = false;

  public query: Query;

  public selectionOptions: SelectionSettingsModel;
  public pageSizes: number[];
  public toolbarOptions: ToolbarItems[];
  public pageSettings: PageSettingsModel;

  paisesList: Pais[];
  itemList: PedidoRemitoDetalle[];
  filteredProveedorList: Proveedor[];
  filteredMaterialList: MaterialDto[] = [];
  tipoMaterialList: TipoMaterialDto[] = [];

  constructor(
    private formBuilder: FormBuilder,
    private sharedFunctions: SharedFunctions,
    private router: Router,
    private menuService: MenuFuncionService,
    private proveedorService: ProveedorService,
    private service: PedidoService,
    private tipoMaterialService: TipoMaterialService,
    private materialService: MaterialesService,
    private datePipe: DatePipe
  ) { }

  ngOnInit(): void {
    this.isValidating = true;
    this.menuService.checkMenu(MenuFuncionCodes.PEDIDO_REPORTE_ENTREGAS_PLANIFICADAS).subscribe(data => {
      this.isValidating = false;
      if (data != null && data.Success && data?.Result)
        this.loadView();
      else {
        this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
        this.router.navigate(['/']);
      }
    },
    (err: HttpErrorResponse) => {
      this.isValidating = false;
      this.sharedFunctions.handleError(err, true);
    });
  }

  loadView() {
    this.canView = true;
    this.pageSizes = GridPageSettings.PageSizeList;
    this.pageSettings = { pageCount: GridPageSettings.PageCount, pageSize: this.pageSizes[1], pageSizes: this.pageSizes };


    this.menuService.checkMenu(MenuFuncionCodes.PROVEEDOR_LIST).subscribe(data => {
      if (data != null && data.Success)
        this.canViewProveedor = (data?.Result ?? false);
    },
    (err: HttpErrorResponse) => {
      this.sharedFunctions.handleError(err);
    });

    this.menuService.checkMenu(MenuFuncionCodes.PEDIDO_LIST).subscribe(data => {
      if (data != null && data.Success)
        this.canViewPedido = (data?.Result ?? false);
    },
    (err: HttpErrorResponse) => {
      this.sharedFunctions.handleError(err);
    });

    this.buildForm();

    this.getMaterialesAutocomplete();
    this.getAutocompleteProveedor();
    this.getTipoMaterial();

    this.setQueryParams();
    this.data = new DataManager({
      url: this.service.searchPedidoPedidoEntregaPlanificada(),
      adaptor: new WebApiAdaptor(),
      headers: [this.service.getAuthorizationHeader(),this.service.getTenantHeader()]
    });
  }

//#region Form

  buildForm() {
    // const today = new Date();
    // const monday = this.getMondayOfWeek(today);
    // const saturday = new Date(monday.getFullYear(), monday.getMonth(), monday.getDate() + 5);

    this.searchForm = this.formBuilder.group({
      'PedidoId': [null],
      'FechaEntregaPlanificadaDesde': [null],
      'FechaEntregaPlanificadaHasta': [null],
      'TipoMaterialId': [null],
      'Proveedor': [null],
      'Material': [null]
    });
  }

//#endregion

//#region Search

  getMondayOfWeek(date: Date): Date {
    const day = date.getDay();
    const diff = date.getDate() - day + (day === 0 ? -6 : 1); // Calcula el lunes de la semana actual
    return new Date(date.setDate(diff));
  }

  onSearch() {
    this.setQueryParams();
    this.grid.refresh();
  }

  setQueryParams() {
    if (this.query == null)
      this.query = new Query();

    var index = this.query.params.findIndex(obj => obj.key === "PedidoId");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.PedidoId;
    else
      this.query.addParams("PedidoId",this.searchForm.value.PedidoId);

    index = this.query.params.findIndex(obj => obj.key === "FechaEntregaPlanificadaDesde");
    if (index >= 0)
    this.query.params[index].value = this.datePipe.transform(this.searchForm.value.FechaEntregaPlanificadaDesde, "yyyy-MM-dd");
    else
      this.query.addParams("FechaEntregaPlanificadaDesde", this.datePipe.transform(this.searchForm.value.FechaEntregaPlanificadaDesde, "yyyy-MM-dd"));

    index = this.query.params.findIndex(obj => obj.key === "FechaEntregaPlanificadaHasta");
    if (index >= 0)
    this.query.params[index].value = this.datePipe.transform(this.searchForm.value.FechaEntregaPlanificadaHasta, "yyyy-MM-dd");
    else
    this.query.addParams("FechaEntregaPlanificadaHasta", this.datePipe.transform(this.searchForm.value.FechaEntregaPlanificadaHasta, "yyyy-MM-dd"));

    index = this.query.params.findIndex(obj => obj.key === "TipoMaterialId");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.TipoMaterialId;
    else
      this.query.addParams("TipoMaterialId",this.searchForm.value.TipoMaterialId);

    index = this.query.params.findIndex(obj => obj.key === "ProveedorId");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.Proveedor?.Id;
    else
      this.query.addParams("ProveedorId",this.searchForm.value.Proveedor?.Id);

    index = this.query.params.findIndex(obj => obj.key === "MaterialId");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.Material?.Id;
    else
      this.query.addParams("MaterialId",this.searchForm.value.Material?.Id);
  }

//#endregion

//#region getters

  getTipoMaterial() {
    var r = new SearchTipoMaterialRequest(null, null, true, "Nombre", null, null, true);
    this.isTipoMaterialSearching = true;

    this.tipoMaterialService.search(r).subscribe(data => {
      this.isTipoMaterialSearching = false;
      this.tipoMaterialList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isTipoMaterialSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

//#endregion

//#region Autocomplete

  getMaterialesAutocomplete() {
    this.searchForm.get('Material')?.valueChanges
    .pipe(
      filter(res => {
        if (res && res !== null && res.length >= 3) {
          this.isMaterialAutoSearching = true;
          return true;
        }
        return false;
      }),
      distinctUntilChanged(),
      debounceTime(3000),
      tap(() => {
        this.filteredMaterialList = [];
        this.isMaterialAutoSearching = true;
      }),
      switchMap(value => this.materialService.search(new SearchMaterialRequest(null, null, null, null, value,null,!isNumber(parseInt(value)) ? value : null, true))
        .pipe(
          finalize(() => {
            this.isMaterialAutoSearching = false;
          }),
        )
      )
    )
    .subscribe((data: any) => {
      this.isMaterialAutoSearching = false;
      if (data != null && data.result != null){
        this.filteredMaterialList = data.result;
      }
      else
        this.filteredMaterialList = [];
    });
  }

  getAutocompleteProveedor() {
    this.searchForm.get("Proveedor")?.valueChanges
    .pipe(
      filter(res => {
        if (res && res !== null && res.length >= 3) {
          this.isProveedorSearching = true;
          return true;
        }
        return false;
      }),
      distinctUntilChanged(),
      debounceTime(3000),
      tap(() => {
          this.filteredProveedorList = [];
      }),
      switchMap(value => this.proveedorService.search(new SearchProveedorRequest(50, null, true, "RazonSocial", null, !isNumber(parseInt(value)) ? value : null, isNumber(parseInt(value)) ? value : null, null, null, null, true))
        .pipe(
          finalize(() => {
            this.isProveedorSearching = false;
          }),
        )
      )
    )
    .subscribe((data: any) => {
      this.isProveedorSearching = false;
      if (data != null && data.result != null) {
        this.filteredProveedorList = data.result;
      }
      else
        this.filteredProveedorList = [];
    });
  }

//#endregion

 //#region actions
  onGridActionFailure(event: any): void {
    this.sharedFunctions.showMessage("Ocurrió un error intentando realizar la búsqueda", "Error");
  }

  viewPedido(pedidoId: number) {
    if (pedidoId == null || pedidoId <= 0) {
      this.sharedFunctions.showMessage("Debe seleccionar un item", "Error");
      return false;
    }

    if (this.canViewPedido)
      this.router.navigate(['pedido-edit', pedidoId]);
  }

  viewProveedor(proveedorId: number) {
    if (proveedorId == null || proveedorId <= 0) {
      this.sharedFunctions.showMessage("Debe seleccionar un item", "Error");
      return false;
    }

    if (this.canViewProveedor)
      this.router.navigate(['proveedores-edit', proveedorId]);
  }

  onExport() {
    var search = new SearchReporteEntregaRequestDto(null, null, null, "", null, null, null, null, null, null);
    // search = Object.assign(search, this.searchForm.value);

    this.isExporting = true;
    this.service.exportReporteEntregas(search).subscribe((data: Blob) => {
        this.isExporting = false;
        var fileUrl = URL.createObjectURL(data);

        var anchor = document.createElement("a");
        anchor.download = "ReporteEntregas_" + this.datePipe.transform(new Date(), "yyyy-MM-dd") + this.sharedFunctions.getFileExtension(ExportMediaTypeConstants.Csv);
        anchor.href = fileUrl;
        anchor.click();
    },
        (err: HttpErrorResponse) => {
            this.isExporting = false;
            this.sharedFunctions.handleError(err, true);
        })
}

  clearDate(formFieldName: string) {
    if (formFieldName != null && formFieldName.length > 0) {
      if (this.searchForm.get(formFieldName) != null && this.searchForm.get(formFieldName)?.value)
        this.searchForm.get(formFieldName)?.setValue(null);
    }
  }

  displayProveedor(proveedor: Proveedor): string {
    return proveedor && proveedor?.RazonSocial ? proveedor.RazonSocial : '';
  }

  displayMaterial(item: MaterialDto): string {
    return item && item?.Nombre ? item.Nombre : '';
  }

  isProcessing() {
    return (this.isSearching);
  }

//#endregion

  getErrorProveedor() {
    return this.searchForm.get('Proveedor')?.hasError('required') ? 'El campo es obligatorio' :'';
  }
}
